import React, { useEffect, useRef, useState } from "react";
import { playerBadgesFor, ratingTierBadgeFor, type PlayerBadge } from "../utils/rating-tier-badges";

type RatingTierIconProps = {
  rating: number;
  playerId?: number;
  size?: number;
};

export default function RatingTierIcon({ rating, playerId, size = 22 }: RatingTierIconProps) {
  const [openLabel, setOpenLabel] = useState<string | null>(null);
  const containerRef = useRef<HTMLSpanElement>(null);
  const badges: PlayerBadge[] = [
    ratingTierBadgeFor(rating),
    ...(playerId === undefined ? [] : playerBadgesFor(playerId)),
  ];
  const openBadge = badges.find((badge) => badge.label === openLabel);

  useEffect(() => {
    if (!openLabel) {
      return;
    }

    function closeOnOutsideClick(event: MouseEvent): void {
      if (!containerRef.current?.contains(event.target as Node)) {
        setOpenLabel(null);
      }
    }

    function closeOnEscape(event: KeyboardEvent): void {
      if (event.key === "Escape") {
        setOpenLabel(null);
      }
    }

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [openLabel]);

  return (
    <span className="rating-tier" ref={containerRef}>
      {badges.map((badge) => (
        <button
          key={badge.label}
          type="button"
          className="rating-tier__toggle"
          aria-expanded={openLabel === badge.label}
          aria-label={`${badge.label} — pokaż historię`}
          onClick={() => setOpenLabel(openLabel === badge.label ? null : badge.label)}
        >
          <img
            className="rating-tier-icon"
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(badge.svg)}`}
            width={size}
            height={size}
            alt=""
          />
        </button>
      ))}

      {openBadge && (
        <span className="rating-tier__bubble" role="status">
          <strong className="rating-tier__title">{openBadge.label}</strong>
          <span className="rating-tier__story">{openBadge.story}</span>
        </span>
      )}
    </span>
  );
}
